import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../../../Paths";
import { State } from "../../../../state/store";
import { CareRecipientListContext } from "../../../provider/CareRecipientListProvider";
import { InputTextBox } from "../../common/input/InputTextBox";
import { PrimaryButton } from "../../disease_knowledge/components/PrimaryButton";

export const CareRecipientListTopArea = React.memo(function CareRecipientListTopArea() {
    const {
        searchText,
        setSearchText
    } = useContext(CareRecipientListContext);

    const navigate = useNavigate();

    const onClick = () => {
        navigate(Paths.addCareRecipient);
    };

    const authUser = useSelector((state: State) => state.auth);

    return (
        <div className="top_area">
            <div className="search_text">
                <InputTextBox value={searchText} handleTextChanged={setSearchText} placeholder="氏名・カスタマーコードで検索"/>
            </div>
            {/* 利用者登録可能なのはトリニティのユーザーのみとする */}
            {authUser.email.endsWith("@trinity-tech.co.jp") &&
                <PrimaryButton onClick={onClick}>利用者追加</PrimaryButton>
            }
        </div>
    );
});

